export const ethiasEnvs = ['dev', 'tst', 'acc', 'prd'];